<template>
  <v-main>
    <LoadingComponent />
  </v-main>
</template>

<script src="./js/loadingLayout.js"></script>